function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { RadialChart } from "react-vis";
import { MAXTheme as theme } from "../Themes/MAXTheme";
export const DonutChart = ({
  data,
  width = 288,
  height = width,
  setRelatedHover,
  onHover,
  ...props
}) => {
  const [hoveredItem, setHoveredItem] = useState({});
  const total = data.reduce((sum, item) => sum += item.value, 0);
  const modifiedData = data.map((point, i) => {
    const opacity = point.id === hoveredItem.id ? 1 : hoveredItem.id ? 0.25 : 1;
    return { ...point,
      angle: point.value / total * 100,
      value: point.value,
      color: theme.charts[i % theme.charts.length],
      opacity: opacity,
      innerRadius: 220,
      radius: 318
    };
  });
  useEffect(() => {
    if (!!setRelatedHover) {
      setHoveredItem(setRelatedHover);
    } else {
      setHoveredItem({});
    }
  }, [setRelatedHover]);

  const handleMouseOver = item => {
    const selected = modifiedData.find(({
      id
    }) => id === item.id);
    setHoveredItem(selected);
    onHover(item);
  };

  const handleMouseLeave = () => {
    setHoveredItem({});
    onHover({});
  };

  const updatedHeight = Number(height) + Number(30);
  const updatedWidth = Number(width) + Number(30);
  return React.createElement(RadialChartContainer, _extends({
    width: width,
    height: height
  }, props), React.createElement(StyledRadialChart, {
    height: updatedHeight,
    width: updatedWidth,
    data: modifiedData,
    colorType: "literal",
    padAngle: 0.025,
    onValueMouseOver: handleMouseOver,
    onMouseLeave: handleMouseLeave
  }));
};
const RadialChartContainer = styled.div`
  position: relative;
  height: ${props => props.height}px;
  width: ${props => props.width}px;
`;
const StyledRadialChart = styled(RadialChart)`
  position: relative;
  left: -15px;
  top: -15px;
`;